// pages/Services.js
import React from "react";
import Header from "../components/home/Header";

import Footer from "../components/home/Footer";
import InternshipApplication from "../components/services/InternshipApplication";




function HrServicePage() {
  return (
    <div>
      <Header />
      <InternshipApplication/>
   
      <Footer />
    </div>
  );
}

export default HrServicePage;
